// extracted by mini-css-extract-plugin
export default {"col_1000":"index_col_1000_Kgbnd","space31":"index_space31_hHAV8","zkcp_title":"index_zkcp_title_MTK-t","zhdsj":"index_zhdsj_gzVos"};